<template>
  <span>{{ title }}</span>
</template>

<script>
export default {
  name: 'ReverseTimer',
  props: {
    seconds: {
      type: Number
    }
  },
  data() {
    return {
      currentTime: 0,
      timer: null
    }
  },
  computed: {
    title() {
      const minutes = Math.floor(this.currentTime / 60)
      const seconds = this.currentTime % 60
      if (seconds < 10) {
        return `${minutes}:0${seconds}`
      }
      return `${minutes}:${seconds}`
    }
  },
  beforeMount() {
    this.currentTime = this.seconds
  },
  mounted() {
    if (!this.timer) {
      this.timer = setInterval(() => {
        if (this.currentTime > 1) {
          this.currentTime--
        } else {
          clearInterval(this.timer)
          this.timer = null
          this.$emit('end')
        }
      }, 1000)
    }
  }
}
</script>
